import { useEffect } from "react"
import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetSeriesList = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/series/list`)
    }, [])

    useEffect(() => {
        if (fetchResult?.statusCode === 500) {
            setAlert("데이터를 가져오는데 실패하였습니다.")
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetSeriesList
